import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DropDownList from 'Components/DropDownToggle/DropDownList/DropDownList';

import Button from 'ui/Button/Button';
import { Navbar, Container, Image, Nav, NavLink } from 'react-bootstrap';

import { ROUTES } from 'constants/routes';
import Styles from './Header.module.scss';
import CustomDropDown from 'Components/DropDownToggle/DropDown';

const Header = () => {
  const navigate = useNavigate();
  const resourceHubItems = [
    {
      id: Math.random(),
      title: 'Blog',
      iconPath: './Images/BlogOutline.svg',
      href: 'https://blog.vocable.ai',
    },
    {
      id: Math.random(),
      title: 'Webinars',
      iconPath: './Images/SocialMedia.svg',
      href: 'https://blog.vocable.ai/webinars',
    },
    {
      id: Math.random(),
      title: 'Tutorials',
      iconPath: './Images/Description.svg',
      href: 'https://www.youtube.com/@Vocable.ai20/playlists',
    },
    {
      id: Math.random(),
      title: 'Community',
      iconPath: './Images/SocialAdHooks.svg',
      href: 'https://community.vocable.ai/join?invitation_token=134f9d229783740438fd41e893e8f60586b09b4a-6ce59293-4998-456c-8ff9-15cb2326a1d1',
    },
    {
      id: Math.random(),
      title: 'Help Center',
      iconPath: './Images/Multi-Team Collaboration.svg',
      href: 'https://blog.vocable.ai/help-centre',
    },
  ];
  const productFeaturesItems = [
    {
      id: Math.random(),
      title: 'Brand Analysis',
      iconPath: './Images/IndustryAnalysis.svg',
      href: '#add-manage-multiple-brands',
    },
    {
      id: Math.random(),
      title: 'AI-Powered Content Campaigns',
      href: '#instantly-generate-content-plans',
      iconPath: './Images/Press Release.svg',
    },
    {
      id: Math.random(),
      title: 'Multi-Model AI Editor',
      href: '#refine-with-ai-assistance',
      iconPath: './Images/IndustryAnalysis.svg',
    },
    {
      id: Math.random(),
      href: '#access-high-converting-templates',
      title: 'AI Templates',
      iconPath: './Images/Description.svg',
    },
  ];

  return (
    <Navbar className={Styles.Navbar} collapseOnSelect expand="xl">
      <Container className={Styles.Navbar_Container} fluid>
        <Navbar.Brand className={Styles.brand_logo}>
          <Link to={ROUTES.HomePage}>
            <Image
              src="/VocableLogo.svg"
              className="d-inline-block align-top"
              alt="Vocable Logo"
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />
        {/* middle section */}
        <Navbar.Collapse>
          <Nav className={Styles.NavLinks}>
            <CustomDropDown
              expandedViewEnabled={false}
              title="Product Features"
              content={productFeaturesItems}
              className={Styles.signIn_btn}
            >
              <DropDownList
                expandedViewEnabled={true}
                listItems={productFeaturesItems}
              />
            </CustomDropDown>
            <CustomDropDown
              expandedViewEnabled={true}
              content={resourceHubItems}
              title="Resource Hub"
              className={Styles.signIn_btn}
            />
            <NavLink
              href="https://vocableai.getrewardful.com/signup"
              target="_blank"
              className={Styles.signIn_btn}
            >
              Get Paid
            </NavLink>
            <NavLink
              onClick={() => {
                navigate('/subscription-plan');
              }}
              className={Styles.signIn_btn}
            >
              Pricing Plans
            </NavLink>
          </Nav>
          {/* right section */}
          <Nav className={Styles.NavActions}>
            <Button
              variant="transparent"
              onClick={() => {
                // setModalType('SIGN-IN');
                // modalViewHandler();
                navigate('/log-in');
              }}
              className={Styles.signIn_btn}
            >
              Sign In
            </Button>
            <Button
              variant="dark"
              shadow
              onClick={() => {
                // setModalType('SIGN-UP');
                // modalViewHandler();
                navigate('/sign-up');
              }}
              className={Styles.signup_btn}
            >
              Start Your Free Trial
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
